import { Box, Button, VStack } from '@chakra-ui/react';

import { WF_ACTION_CALENDAR_EVENT } from '@/constants/workflows/wf-action-event';
import { IWorkflow } from '@/types/workflows/IWorkflow';
import { t } from 'i18next';
import { useFieldArray, useForm } from 'react-hook-form';
import { VscAdd, VscArrowDown } from 'react-icons/vsc';
import ActionsSection from './components/actions-section/actions-section.view';
import TriggerSection from './components/trigger-section/trigger-section.view';

export default function EditWorkflowView() {
	const form = useForm<IWorkflow>({
		defaultValues: {
			type: 'PutAfterConfirmingBookingWorkflowRequest',
			actions: [],
		},
	});

	const actionsFieldArray = useFieldArray({
		name: 'actions',
		control: form.control,
	});

	return (
		<Box display="grid" gridTemplateColumns="1fr">
			<Box>
				<TriggerSection form={form} />

				<Box p={4} display="grid" justifyContent="center" alignItems="center">
					<VscArrowDown />
				</Box>

				<VStack
					divider={
						<Box display="grid" justifyContent="center" alignItems="center" borderBottom="none">
							<VscAdd />
						</Box>
					}
					display="grid"
					gap={4}
				>
					{actionsFieldArray.fields.map((field, index) => {
						return (
							<ActionsSection
								index={index}
								onRemove={() => actionsFieldArray.remove(index)}
								key={field.id}
								form={form}
							/>
						);
					})}
				</VStack>

				<Box
					display={actionsFieldArray.fields.length === 0 ? 'none' : 'grid'}
					p={4}
					justifyContent="center"
					alignItems="center"
				>
					<VscArrowDown />
				</Box>

				<Box display="grid" justifyContent="center" alignItems={'center'}>
					<Button
						mx="auto"
						onClick={() => {
							actionsFieldArray.append(WF_ACTION_CALENDAR_EVENT);
						}}
					>
						{t('Add action')}
					</Button>
				</Box>
			</Box>

			{/* <Box p={8}>
				<pre>{JSON.stringify(form.watch(), null, 2)}</pre>
			</Box> */}
		</Box>
	);
}
